import React from 'react'
import Navbar from './Navbar'
import "../styles/style.css"


export default function Layout({ children }) {
    return (
        <div className="Layout">
            <div className="container">
            <Navbar />
            </div>
            <div className="content">
                { children }
            </div>
            <footer>
                <p id="bottom">CXMOBL Deployment Page - Courier Express</p>
            </footer>
        </div>
    )
}

